import { render, staticRenderFns } from "./Financial.vue?vue&type=template&id=b0806972&scoped=true"
import script from "./Financial.vue?vue&type=script&lang=js"
export * from "./Financial.vue?vue&type=script&lang=js"
import style0 from "./Financial.vue?vue&type=style&index=0&id=b0806972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0806972",
  null
  
)

export default component.exports